import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Swipper.css";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";

const Category5 = ({ data }) => {
  // Dummy data for categories with placeholder images

  const [backgroundColor, setBackgroundColor] = useState("");
  const [title, setTitle] = useState("");
  const [titleColor, setTitleColor] = useState("");
  const [titleFont, setTitleFont] = useState("");
  const [titleAlignment, setTitleAlignment] = useState("");
  const [cornerRedious, setCornerRedious] = useState("");
  const [itemMargin, setItemMargin] = useState("");
  const [itemPadding, setItemPadding] = useState("");
  const [labelPosition, setLabelPosition] = useState("");
  const [textAlignment, setTextAlignment] = useState("");
  const swiperRef_c_5 = useRef(null);
  const [labelFont, setLabelFont] = useState("");
  const [labelColor, setLabelColor] = useState("");


  useEffect(() => {
    setBackgroundColor(component.web_background_color);
    setTitleColor(component.web_title_color);
    setTitleFont(component.web_title_font);
    setTitleAlignment(component.title_alignment);
    setCornerRedious(component.corner_radius);
    setItemMargin(component.item_margin);
    setItemPadding(component.item_padding);
    setLabelPosition(component.label_position);
    setTextAlignment(component.text_alignment);
    setTitle(component.title);
    setLabelFont(component.label_font);
    setLabelColor(component.label_color);

  }, []);

  const component = data;
  const categories = data["get_home_component_details"]["content"];

  const loadGoogleFont = (fontName) => {
    if (!fontName) return;

    const f = fontName.trim();
    const lower = f.toLowerCase();

    if (lower === "sans" || lower === "serif" || lower === "mono") return;

    const formatted = f.replace(/\s+/g, "+");
    const id = `gf-${formatted.toLowerCase()}`;

    if (document.getElementById(id)) return;

    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${formatted}&display=swap`;
    document.head.appendChild(link);
  };

  const getFontFamily = (font) => {
    if (!font) return "inherit";

    const f = font.toLowerCase().trim();

    if (f === "sans") return "ui-sans-serif, system-ui, -apple-system, sans-serif";
    if (f === "serif" || f === "sherif")
      return 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif';
    if (f === "mono")
      return 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';

    return font;
  };

  useEffect(() => {

    loadGoogleFont(titleFont);
    loadGoogleFont(labelFont);
  }, [labelFont,titleFont]);



  const truncateNameMobile = (name) => {
    return name.length > 6 ? name.substring(0, 6) + "..." : name;
  };

  const truncateNameDesktop = (name) => {
    return name.length > 15 ? name.substring(0, 15) + "..." : name;
  };

  return (
    <div className="px-2 py-3" style={{ backgroundColor: backgroundColor }}>
      {" "}
      {/* Padding on both sides */}
      {/* Desktop View: 6 Cards per Row, No Gap, Fully Rounded */}
      <div
        className={`text-2xl font-bold ${titleAlignment === "center"
          ? "text-center"
          : titleAlignment === "start"
            ? "text-left"
            : "text-center"
          }`}
        style={{
          color: titleColor,
          fontFamily: getFontFamily(titleFont),
        }}
      >
        {title}
      </div>
      {textAlignment === "" && (
        <div className="flex-wrap justify-center hidden space-x-0 overflow-hidden lg:flex">
          {categories.map((category) => (
            <div
              key={category.maincategory_auto_id}
              className="flex justify-center"
            >
              <div
                className="flex items-center p-2 text-center"
                style={{
                  maxWidth: "160px",
                  borderRadius: cornerRedious,
                  margin: itemMargin,
                  padding: itemPadding,
                }}
              >
                <Link
                  to={`/maincategory/${category.maincategory_auto_id}`}
                  className="flex flex-col items-center text-decoration-none"
                >
                  {/* Fully borderRadius Image */}
                  <img
                    src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                    alt={category.main_category_name}
                    className="object-cover borderRadius"
                    style={{ height: "200px", width: "140px" }}
                  />
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
      {textAlignment === "beside" && (
        <div className="flex-wrap justify-center hidden space-x-0 overflow-hidden lg:flex">
          {categories.slice(0, 8).map((category) => (
            <div
              key={category.maincategory_auto_id}
              className="flex justify-center"
            >
              <div
                className="flex items-center p-2 text-center"
                style={{
                  maxWidth: "160px",
                  borderRadius: cornerRedious,
                  margin: itemMargin,
                  padding: itemPadding,
                }}
              >
                <Link
                  to={`/maincategory/${category.maincategory_auto_id}`}
                  className="flex flex-col items-center text-decoration-none"
                >
                  {/*  Fully borderRadius Image */}
                  <img
                    src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                    alt={category.main_category_name}
                    className="object-cover borderRadius"
                    style={{ height: "200px", width: "140px" }}
                  />
                  <p
                    className="mt-2 text-sm"
                    style={{ color: labelColor || "#000000", fontFamily: getFontFamily(labelFont) }}
                  >
                    {truncateNameDesktop(category.main_category_name)}
                  </p>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
      {textAlignment === "bottom" && (
        <div className="flex-wrap justify-center hidden space-x-0 overflow-hidden lg:flex">
          {categories.slice(0, 8).map((category) => (
            <div
              key={category.maincategory_auto_id}
              className="flex justify-center"
              style={{
                borderRadius: cornerRedious,
                m: itemMargin,
                p: itemPadding,
              }}
            >
              <div
                className="relative flex items-center p-2 text-center"
                style={{
                  maxWidth: "160px",
                  borderRadius: cornerRedious,
                  margin: itemMargin,
                  padding: itemPadding,
                }}
              >
                <Link
                  to={`/maincategory/${category.maincategory_auto_id}`}
                  className="flex flex-col items-center text-decoration-none"
                >
                  {/* Image */}
                  <div className="relative">
                    <img
                      src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                      alt={category.main_category_name}
                      className="object-cover rounded"
                      style={{ height: "200px", width: "140px" }}
                    />
                    {/* Name Overlay ONLY at Bottom */}
                    <div
                      className="absolute bottom-0 left-0 right-0 p-1 py-3 text-sm font-medium text-center bg-opacity-75 rounded-b bg-gray-800/40"
                      style={{ 
                        color: labelColor || "#ffffff", 
                        fontFamily: getFontFamily(labelFont),
                        textAlign: labelPosition }}
                    >
                      {truncateNameDesktop(category.main_category_name)}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
      {textAlignment === "center" && (
        <div className="flex-wrap justify-center hidden space-x-0 overflow-hidden lg:flex">
          {categories.slice(0, 8).map((category) => (
            <div
              key={category.maincategory_auto_id}
              className="flex justify-center"
            >
              <div
                className="relative flex items-center p-2 text-center"
                style={{
                  maxWidth: "160px",
                  borderRadius: cornerRedious,
                  margin: itemMargin,
                  padding: itemPadding,
                }}
              >
                <Link
                  to={`/maincategory/${category.maincategory_auto_id}`}
                  className="flex flex-col items-center text-decoration-none"
                >
                  {/* Image Wrapper */}
                  <div className="relative">
                    {/* Image */}
                    <img
                      src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                      alt={category.main_category_name}
                      className="object-cover rounded"
                      style={{ height: "200px", width: "140px" }}
                    />
                    {/* Black Overlay (30% Opacity) */}
                    <div className="absolute inset-0 rounded bg-gray-800/30"></div>
                    {/* Name Overlay Centered Over Image */}
                    <div className="absolute text-lg font-bold text-center uppercase -translate-x-1/2 top-1/2 left-1/2 drop-shadow-lg" style={{ color: labelColor || "#ffffff", fontFamily: getFontFamily(labelFont) }}>
                      {truncateNameDesktop(category.main_category_name)}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
      {textAlignment === "top" && (
        <div className="flex-wrap justify-center hidden space-x-0 overflow-hidden lg:flex">
          {categories.slice(0, 8).map((category) => (
            <div
              key={category.maincategory_auto_id}
              className="flex justify-center"
            >
              <div
                className="relative flex items-center p-2 text-center"
                style={{
                  maxWidth: "160px",
                  borderRadius: cornerRedious,
                  margin: itemMargin,
                  padding: itemPadding,
                }}
              >
                <Link
                  to={`/maincategory/${category.maincategory_auto_id}`}
                  className="flex flex-col items-center text-decoration-none"
                >
                  {/* Image */}
                  <div className="relative">
                    <img
                      src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                      alt={category.main_category_name}
                      className="object-cover rounded"
                      style={{ height: "200px", width: "140px" }}
                    />
                    {/* Name Overlay ONLY at the Top */}
                    <div className="absolute top-0 left-0 right-0 p-1 py-3 text-sm font-medium text-center bg-opacity-75 rounded-t bg-gray-800/40" style={{ color: labelColor || "#ffffff", fontFamily: getFontFamily(labelFont) }}>
                      {truncateNameDesktop(category.main_category_name)}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
      {/* Mobile View: Rounded Carousel with 4 Items */}
      {textAlignment === "" && (
        <div className="relative lg:hidden">
          <Swiper
            ref={swiperRef_c_5}
            slidesPerView={4}
            spaceBetween={10}
            navigation={{
              nextEl: `.swiper-button-next-${data._id}`,
              prevEl: `.swiper-button-prev-${data._id}`,
            }}
            modules={[Navigation]}
            className="mySwiper"
          >
            {categories.map((category) => (
              <SwiperSlide key={category.maincategory_auto_id}>
                <div className="flex justify-center">
                  <div className="flex items-center p-1 text-center">
                    <Link
                      to={`/maincategory/${category.maincategory_auto_id}`}
                      className="flex flex-col items-center text-decoration-none"
                    >
                      {/* Fully Rounded Image */}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                        alt={category.main_category_name}
                        className="object-cover rounded"
                        style={{ height: "140px", width: "80px" }}
                      />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Arrows */}
          {/* <div className={`swiper-button-next-${data._id}`}></div>
                    <div className={`swiper-button-prev-${data._id}`}></div> */}
        </div>
      )}
      {textAlignment === "beside" && (
        <div className="relative lg:hidden">
          <Swiper
            ref={swiperRef_c_5}
            slidesPerView={4}
            spaceBetween={10}
            navigation={{
              nextEl: `.swiper-button-next-${data._id}`,
              prevEl: `.swiper-button-prev-${data._id}`,
            }}
            modules={[Navigation]}
            className="mySwiper"
          >
            {categories.map((category) => (
              <SwiperSlide key={category.maincategory_auto_id}>
                <div className="flex justify-center">
                  <div className="flex items-center p-1 text-center">
                    <Link
                      to={`/maincategory/${category.maincategory_auto_id}`}
                      className="flex flex-col items-center text-decoration-none"
                    >
                      {/* Fully Rounded Image */}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                        alt={category.main_category_name}
                        className="object-cover rounded"
                        style={{ height: "140px", width: "80px" }}
                      />
                      <p className="mt-2 text-sm" style={{ color: labelColor || "#000000", fontFamily: getFontFamily(labelFont) }}>
                        {truncateNameMobile(category.main_category_name)}
                      </p>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Arrows */}
          {/* <div className={`swiper-button-next-${data._id}`}></div>
                    <div className={`swiper-button-prev-${data._id}`}></div> */}
        </div>
      )}
      {textAlignment === "bottom" && (
        <div className="relative lg:hidden">
          <Swiper
            ref={swiperRef_c_5}
            slidesPerView={4}
            spaceBetween={10}
            navigation={{
              nextEl: `.swiper-button-next-${data._id}`,
              prevEl: `.swiper-button-prev-${data._id}`,
            }}
            modules={[Navigation]}
            className="mySwiper"
          >
            {categories.map((category) => (
              <SwiperSlide key={category.maincategory_auto_id}>
                <div className="flex justify-center">
                  <div className="flex items-center p-1 text-center">
                    <Link
                      to={`/maincategory/${category.maincategory_auto_id}`}
                      className="flex flex-col items-center text-decoration-none"
                    >
                      {/* Fully Rounded Image */}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                        alt={category.main_category_name}
                        className="object-cover rounded"
                        style={{ height: "140px", width: "80px" }}
                      />
                      <div className="absolute bottom-0 left-0 right-0 p-1 py-2 m-1 text-sm font-medium text-center bg-opacity-75 rounded-b bg-gray-800/40" style={{ color: labelColor || "#ffffff", fontFamily: getFontFamily(labelFont) }}>
                        {truncateNameMobile(category.main_category_name)}
                      </div>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Arrows */}
          {/* <div className={`swiper-button-next-${data._id}`}></div>
                    <div className={`swiper-button-prev-${data._id}`}></div> */}
        </div>
      )}
      {textAlignment === "center" && (
        <div className="relative lg:hidden">
          <Swiper
            ref={swiperRef_c_5}
            slidesPerView={4}
            spaceBetween={10}
            navigation={{
              nextEl: `.swiper-button-next-${data._id}`,
              prevEl: `.swiper-button-prev-${data._id}`,
            }}
            modules={[Navigation]}
            className="mySwiper"
          >
            {categories.map((category) => (
              <SwiperSlide key={category.maincategory_auto_id}>
                <div className="flex justify-center">
                  <div className="flex items-center p-1 text-center">
                    <Link
                      to={`/maincategory/${category.maincategory_auto_id}`}
                      className="flex flex-col items-center text-decoration-none"
                    >
                      {/* Fully Rounded Image */}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                        alt={category.main_category_name}
                        className="object-cover rounded"
                        style={{ height: "140px", width: "80px" }}
                      />
                      {/* Black Overlay (30% Opacity) */}
                      <div className="absolute inset-0 m-1 rounded bg-gray-800/30"></div>
                      {/* Name Overlay Centered Over Image */}
                      <div className="absolute text-lg font-bold text-center uppercase -translate-x-1/2 top-1/2 left-1/2 drop-shadow-lg" style={{ color: labelColor || "#ffffff", fontFamily: getFontFamily(labelFont) }}>
                        {truncateNameMobile(category.main_category_name)}
                      </div>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Arrows */}
          {/* <div className={`swiper-button-next-${data._id}`}></div>
                    <div className={`swiper-button-prev-${data._id}`}></div> */}
        </div>
      )}
      {textAlignment === "top" && (
        <div className="relative lg:hidden">
          <Swiper
            ref={swiperRef_c_5}
            slidesPerView={4}
            spaceBetween={10}
            navigation={{
              nextEl: `.swiper-button-next-${data._id}`,
              prevEl: `.swiper-button-prev-${data._id}`,
            }}
            modules={[Navigation]}
            className="mySwiper"
          >
            {categories.map((category) => (
              <SwiperSlide key={category.maincategory_auto_id}>
                <div className="flex justify-center">
                  <div className="flex items-center p-1 text-center">
                    <Link
                      to={`/maincategory/${category.maincategory_auto_id}`}
                      className="flex flex-col items-center text-decoration-none"
                    >
                      {/* Fully Rounded Image */}
                      <img
                        src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                        alt={category.main_category_name}
                        className="object-cover rounded"
                        style={{ height: "140px", width: "80px" }}
                      />
                      <div className="absolute top-0 left-0 right-0 p-1 py-2 m-1 text-sm font-medium text-center bg-opacity-75 rounded-b bg-gray-800/40" style={{ color: labelColor || "#ffffff", fontFamily: getFontFamily(labelFont) }}>
                        {truncateNameMobile(category.main_category_name)}
                      </div>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Arrows */}
          {/* <div className={`swiper-button-next-${data._id}`}></div>
                    <div className={`swiper-button-prev-${data._id}`}></div> */}
        </div>
      )}
    </div>
  );
};

export default Category5;
